import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAzuredataexplorerComponent } from './simple-icons-azuredataexplorer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAzuredataexplorerComponent ],
    exports:      [ SimpleIconsAzuredataexplorerComponent ],
    bootstrap:    []
})
export class SimpleIconsAzuredataexplorerModule {}
